import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import Markdown from 'react-markdown';

import BackArrow from './Komponenty/BackArrow';
import DocSection from './Komponenty/DocSection';


export default function ProjectPage() {
    const { projectId } = useParams();

    const [projekty, setProjekty] = useState([]);
    const [projekt, setProjekt] = useState(null);

    const firebaseConfig = {
        apiKey: "AIzaSyA9awgIBkxiIbZSsQzsPRlzOnI14ZhceH0",
        authDomain: "portfolio-c10d1.firebaseapp.com",
        projectId: "portfolio-c10d1",
        storageBucket: "portfolio-c10d1.appspot.com",
        messagingSenderId: "169094375046",
        appId: "1:169094375046:web:d45e07e8a74fa30b0c9307"
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);

    useEffect(() => {
        const fetchData = async () => {
            const projekty_array = [];
            const querySnapshot = await getDocs(collection(db, "projekty"));
            querySnapshot.forEach((doc) => {
                const dataWithId = { ...doc.data(), id: doc.id };
                projekty_array.push(dataWithId);
            });

            // Filter duplicates before setting the state
            const uniqueProjekty = projekty_array.filter((projekt, index, self) =>
                index === self.findIndex((t) => (
                    t.nazwa === projekt.nazwa
                ))
            );
            setProjekty(uniqueProjekty);

            // Move the logic for setting projekt here, after projekty is populated
            const p = uniqueProjekty.find((projekt) => projekt.id === projectId); // Use uniqueProjekty directly
            setProjekt(p);
        };
        fetchData();
    }, [projectId]); // Add projectId as a dependency to re-fetch data when it changes

    return (
        <>
            <BackArrow />
            <div className="flex">
                <div className="w-1/4 bg-gradient-to-b from-[#061e3d] via-[#07192d] to-[#061e3d] p-4 shadow-lg transition-all duration-500 ease-in-out">
                    <h2 className="font-bold text-2xl mb-2 text-white">
                        {projekt && projekt.nazwa}
                    </h2>
                    <ul className="space-y-2">
                        <li><a href="#introduction" className="text-white hover:underline transition-colors duration-300">Introduction</a></li>
                        <li><a href="#quickstart" className="text-white hover:underline transition-colors duration-300">Quick Start</a></li>
                        <li><a href="#technologies" className="text-white hover:underline transition-colors duration-300">Technologies used</a></li>
                        <li><a href="#description" className="text-white hover:underline transition-colors duration-300">Description</a></li>
                        <li><a href="#examples" className="text-white hover:underline transition-colors duration-300">Examples</a></li>
                        <li><a href="#faq" className="text-white hover:underline transition-colors duration-300">FAQ</a></li>
                    </ul>
                </div>
                <div className="w-3/4 p-8">
                    <DocSection id="introduction" text="Introduction">
                        <p>
                            <Markdown>
                                {projekt && projekt.introduction}
                            </Markdown>
                        </p>
                    </DocSection>
                    <DocSection id="quickstart" text="Quick Start">
                        <p>
                            <Markdown>
                                {projekt && projekt.quick_start}
                            </Markdown>
                        </p>
                    </DocSection>
                    <DocSection id="technologies" text="Technologies used">
                        <p>
                            <Markdown>
                                {projekt && projekt.tech_used}
                            </Markdown>
                        </p>
                    </DocSection>
                    <DocSection id="description" text="Description">
                        <p>
                            <Markdown>
                                {projekt && projekt.describtion}
                            </Markdown>
                        </p>
                    </DocSection>
                    <DocSection id="examples" text="Examples">
                        <p>
                            <Markdown>
                                {projekt && projekt.examples}
                            </Markdown>
                        </p>
                    </DocSection>
                    <DocSection id="faq" text="FAQ">
                        <p>
                            <Markdown>
                                {projekt && projekt.faq}
                            </Markdown>
                        </p>
                    </DocSection>
                </div>
            </div>
        </>
    );
}
